import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import { Observable } from 'rxjs';

import { Router } from '@angular/router';
import { LineItem } from 'src/app/models/line-item.model';
import { Order } from 'src/app/models/order.model';
import { Task } from 'src/app/models/task.model';
import { User } from 'src/app/models/user.model';
import { TaskService } from '../../services';

@Component({
  selector: 'app-line-item-detail',
  templateUrl: './line-item-detail.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LineItemDetailComponent implements OnChanges {
  @Input() order: Order;

  @Input() lineItem: LineItem;

  @Input() areOrdersLoading: boolean;

  @Input() browserSize: string;

  @Output() openContactInformationModal = new EventEmitter<{
    user: User;
    title: string;
  }>();

  tasks$: Observable<Task[]>;

  isLineItemAvailable = false;

  isTasksLoading = true;

  isTasksLoaded = false;

  hasTasksError = false;

  private taskService = inject(TaskService);

  private router = inject(Router);

  ngOnChanges(): void {
    if (this.browserSize !== 'small') {
      this.router.navigateByUrl('/orders');
    }

    if (!this.lineItem || !this.order) {
      this.isLineItemAvailable = false;
    } else {
      this.isLineItemAvailable = true;
      if (this.lineItem.Service_Order2__c) {
        this.getLineItemTasks(this.lineItem.Service_Order2__c);
      }
    }
  }

  viewContactInformation(user: User, title: string): void {
    this.openContactInformationModal.emit({ user, title });
  }

  private getLineItemTasks(serviceOrderId: string): void {
    this.tasks$ = this.taskService.getTasks(serviceOrderId);
    this.tasks$.subscribe(
      () => {
        this.isTasksLoading = false;
        this.isTasksLoaded = true;
      },
      () => {
        this.isTasksLoading = false;
        this.isTasksLoaded = false;
        this.hasTasksError = true;
      },
    );
  }
}
